function GetToken(state) {
    state.token = localStorage.getItem('user');
    return state.token;
}

export {
    GetToken
}


// WEBPACK FOOTER //
// ./src/modules/login/store/getters.js